export default function TwitchEmbed({ channel }) {
  const parent = window.location.hostname;

  return (
    <iframe
      title="Twitch Stream"
      src={`https://player.twitch.tv/?channel=${encodeURIComponent(channel)}&parent=${encodeURIComponent(parent)}`}
      width="100%"
      height="100%"
      frameBorder="0"
      allowFullScreen
    />
  );
}